var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', _vm._g({
    staticClass: "absolute-fill gc-border",
    class: {
      clickable: _vm.clickable
    }
  }, _vm.clickable ? {
    click: function () {
      return _vm.$emit('click');
    }
  } : {}));

}
var staticRenderFns = []

export { render, staticRenderFns }